const Component = () => import('./PaymentForm');

export { Component };
